export const INPUT_TEXT_COLOUR = '#292929';

export const ERROR_COLOUR = '#a82700';
export const INPUT_BORDER_COLOR = '#696969';
export const INPUT_DISABLED_COLOUR = '#fafafa';
